import type {UpmPlantsContextValue} from '../types'

import {getPlantName} from './getPlantName'

export const plantIdsByPlantNameCompareFn =
  (upmPlants: UpmPlantsContextValue, direction: 'asc' | 'desc' = 'asc') =>
  (plantIdA: string, plantIdB: string) => {
    const comparison =
      getPlantName(upmPlants, plantIdA) > getPlantName(upmPlants, plantIdB) ? 1 : -1
    return direction === 'asc' ? comparison : -comparison
  }
